import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import { ProfileModel, } from '@common/domain/models/Profile';
import { FormHelper, } from '@utils/FormHelper';
import CalendarComponent from '@presentation/Mentors/Component/CalenderComponent';
import CalComponent from '@presentation/Mentors/Component/CalComponent';
import { getFetchProfileLoaderSelector, getProfileMap } from '@common/redux/profile/selectors';
import { fetchProfilesByUserIds } from '@common/redux/profile/actions';
import GobackArrow from '@components/molecules/GoBack';
import Shimmer from '@components/atoms/Shimmer';
import './styles.less';

interface IProps {
    profileMap: {},
    isFetchingProfile: boolean;
    fetchProfile: (userId: string) => void;
}

const BookSessionWithCareerBuddyCalendar = (props: IProps) => {
    const { fetchProfile, isFetchingProfile, profileMap } = props
    const { pathname } = useLocation();
    const pathNameArray = pathname?.split("/");
    const userId = pathNameArray[pathNameArray?.length - 1];
    const mentor: ProfileModel = profileMap[profileMap[userId]]
    const calcomUrl = mentor?.getCalcomUrl();

    useEffect(() => {
        if (userId) {
            fetchProfile(userId)
        }
    }, [userId])

    if (isFetchingProfile) {
        return <Shimmer />
    }

    return <div className="book-session-with-career-buddy-calendar">
        <GobackArrow />
        {!mentor?.getSlotTags() ?
            FormHelper.validCalcomUrl(calcomUrl) && <CalComponent url={calcomUrl} />
            : <CalendarComponent profile={mentor} />}
    </div>
};


const mapStateToProps = (state, props) => ({
    profileMap: getProfileMap(state),
    isFetchingProfile: getFetchProfileLoaderSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchProfile: (userId: string) => dispatch(fetchProfilesByUserIds([userId])),
});

export default
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(BookSessionWithCareerBuddyCalendar);


